/* eslint-disable @typescript-eslint/default-param-last */
import { IAlertAction } from '../types/alert.types';
import { HIDE_ALERT, SHOW_ALERT } from '../constants/ActionTypes';
import initialState from '../store/initialState';

const alertReducer = (state = initialState.alert, action: IAlertAction) => {
  switch (action.type) {
    case SHOW_ALERT:
      return { ...state, ...action.payload };
    case HIDE_ALERT:
      return {
        ...state,
        ...initialState.alert,
      };
    default:
      return state;
  }
};

export default alertReducer;
